import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormFooter from '../../../components/form-footer';
import IntakeSceneInvestigationDetailsFields from '../../../components/intake/scene-investigation/details-fields';
import SceneInvestigationDetailsSchema from '../../../validation-schemas/scene-investigation-details-schema';
import { updateActiveFormSceneInvestigationDetails, selectActiveFormSceneInvestigationDetails } from '../../../reducers/active-form-slice';
import FormHeaderButtons from '../form-header-buttons';
import { hasNonBlankValues } from '../../../utility/has-values';


const IntakeSceneInvestigationDetails = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();


    /**
     * get current form values
     */
    const sceneInvestigationDetails = useSelector(selectActiveFormSceneInvestigationDetails);
    const hasValues = hasNonBlankValues(sceneInvestigationDetails);


    /**
     * handle the previous button
     */
    const handlePrevious = () => {
        navigate("/intake/");
    };


    /**
     * update active form & continue
     */
    const handleSubmit = (values) => {
        dispatch(updateActiveFormSceneInvestigationDetails(values));
        navigate("/intake/additional-information");
    };

    /**
     * handle save for later
     */
    const handleSaveForLater = (values) => {
        dispatch(updateActiveFormSceneInvestigationDetails(values));
    };


    /**
     * setup the initial values
     */
    const initialValues = {
        dateOfLoss: '',
        timeOfLoss: '',
        surveillanceType: '',
        investigationSubject: '',
        investigationLocation: '',
        subjectVehicleDescription: '',
        subjectVehiclelicensePlate: '',
        factsOfLoss: '',
    };


    return (
        <div className="page intake">
            <Formik
                initialValues={hasValues ? sceneInvestigationDetails : initialValues}
                validationSchema={SceneInvestigationDetailsSchema.fields.sceneInvestigationDetails}
                onSubmit={handleSubmit}
            >
                {({ errors, dirty, isValid, touched, values }) => (
                    <Form>
                        <div className="form-header-buttons">
                            <div>
                                <h2>Scene Investigation Details</h2>
                                <p>FILL WITH “N/A” IF NOT APPLICABLE ON REQUIRED FIELDS</p>
                            </div>
                            <FormHeaderButtons updateForm={() => handleSaveForLater(values)}/>
                        </div>
                
                        <IntakeSceneInvestigationDetailsFields
                            errors={errors}
                            values={values}
                            touched={touched}
                        />

                        <FormFooter
                            handlePrevious={handlePrevious}
                            showPrevious={true}
                            disableNext={!((dirty || hasValues) && isValid)}
                            showNext={true}
                            progress={`50`}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default IntakeSceneInvestigationDetails;